module.exports = __webpack_public_path__ + "img/tecnotion-blue.41e6ceec.png";